import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    console.log(to)
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: ()=>import("@/layout/default"),
      children: [
        // {path: '/', name: 'Index', component: () =>import("@/views/index/index")},
        {path: '/', name: 'Index', component: () =>import("@/views/new/index")},
        {path: '/books', name: 'Books', component: () =>import("@/views/new/books")},
        {path: '/book/detail', name: 'BookDetail', component: () =>import("@/views/new/bookDetail")},
        {path: '/factory', name: 'Factory', component: () =>import("@/views/new/factory")},
        {path: '/factory/detail', name: 'FactoryDetail', component: () =>import("@/views/new/factoryDetail")},
        {path: '/video', name: 'Video', component: () =>import("@/views/new/video")},
        {path: '/article', name: 'Article', component: () =>import("@/views/new/article")},
        {path: '/article/detail', name: 'ArticleDetail', component: () =>import("@/views/new/articleDetail")},
        {path: '/contact', name: 'Contact', component: () =>import("@/views/new/contact")},
        {path: '/login', name: 'Login', component: () =>import("@/views/new/login")},
        {path: '/forgot', name: 'Forgot', component: () =>import("@/views/new/forgot")},
        {path: '/register', name: 'Register', component: () =>import("@/views/new/register")},
        {path: '/register/success', name: 'RegisterSuccess', component: () =>import("@/views/new/registerSuccess")},
        {path: '/collect', name: 'Collect', component: () =>import("@/views/new/collect")},
        {path: '/track', name: 'Track', component: () =>import("@/views/new/track")},
        {path: '/user/contact', name: 'UserContact', component: () =>import("@/views/new/userContact")},
        {path: '/user/settle', name: 'UserSettle', component: () =>import("@/views/new/userSettle")},
        {path: '/user/set', name: 'UserSet', component: () =>import("@/views/new/set")},
        {path: '/search', name: 'Search', component: () =>import("@/views/new/search")},


        // {path: '/about', name: 'About', component: () =>import("@/views/index/about")},
        // {path: '/exibition', name: 'Exibition', component: () =>import("@/views/index/exibition")},
        // {path: '/contact', name: 'Contact', component: () =>import("@/views/index/contact")},
        // {path: '/factory-list', name: 'FactoryList', component: () =>import("@/views/index/factory-list")},
        // {path: '/factory-detail', name: 'FactoryDetail', component: () =>import("@/views/index/factory-detail")},
        // {path: '/login', name: 'Login', component: () =>import("@/views/index/login")},
        // {path: '/register', name: 'Register', component: () =>import("@/views/index/register")},
        // {path: '/user', name: 'User', component: () =>import("@/views/index/user")},
        // {path: '/history', name: 'History', component: () =>import("@/views/index/history")},
        // {path: '/customer', name: 'Customer', component: () =>import("@/views/index/customer")},
        // {path: '/apply', name: 'Apply', component: () =>import("@/views/index/apply")},
        // {path: '/userset', name: 'UserSet', component: () =>import("@/views/index/user-set")},
        // {path: '/editinfo', name: 'EditInfo', component: () =>import("@/views/index/editinfo")},
        // {path: '/editpassword', name: 'EditPassword', component: () =>import("@/views/index/edit-password")},
        // {path: '/editphone', name: 'EditPhone', component: () =>import("@/views/index/editphone")},
        // {path: '/editemail', name: 'EditEmail', component: () =>import("@/views/index/editEmail")},
        // {path: '/avatar', name: 'Avatar', component: () =>import("@/views/index/avatar")},
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js